<navigation-button
  [indent]="indent"
  (click)="openTagItems()"
  scsStopPropagation>
  <ng-container icon>
    <scs-svg-icon name="tag"></scs-svg-icon>
  </ng-container>

  {{ tag.name }}

  <ng-container addons>
    <navigation-button-addon *ngIf="loading$ | async">
      <span><fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon></span>
    </navigation-button-addon>
  </ng-container>
</navigation-button>
